<template>
  <div id="app" class="Site">
    <main class="Site-content">
      <navbar />
      <router-view />
    </main>
    <foot />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Foot from "@/components/Foot.vue";

export default {
  components: {
    Navbar,
    Foot
  }
};
</script>

<style lang="scss">
.Site {
  display: flex;
  min-height: calc(100vh - 5.5rem);
  flex-direction: column;
}

.Site-content {
  flex: 1;
}
</style>
